/** The file frame's chrome. */
export default {
  noFile: "No file attached",
  openFile: "Open {name}",
  thisFile: "file",
  pdfPages: { one: "PDF · {count} page", other: "PDF · {count} pages" },
  pageNumber: "Page {number}",
  openInBrowser: "Open in browser",
  pdfRefused: "This PDF's site doesn't allow previews here.",
  pdfNotPdf: "This link isn't a PDF.",
  pdfTooLarge: "This PDF is too large to preview.",
  pdfFailed: "This PDF couldn't be loaded.",
  onComputer: "On {name}",
  anotherComputer: "another computer",
  fileOnOtherComputer: "This file is on {name}. Open it there.",
  fileNotFound: "File not found",
  fileNotFoundHint: "It was moved or deleted. Locate it to link it again.",
  locateFile: "Locate…",
  showInFinder: "Show in Finder",
  showInExplorer: "Show in Explorer",
  folderAccessDenied: "macOS doesn’t let Denker open this file’s folder.",
  allowInSettings: "Allow in Settings",
  fileOpenFailed: "Couldn’t open {name}",
  fileShownInstead:
    "{name} could run something, so it’s shown instead of opened.",
  notLinkedHere: "Not linked on this computer",
  notLinkedHint: "Pick the file to link it to this card here.",
  linkFile: "Link a file…",
} as const;
